export type BackgroundTaskKind = 'INVOICE_BULK_UPLOAD' | 'PURCHASE_ORDER_PROBLEM_BATCH'

export type BackgroundTaskState = 'QUEUED' | 'PROCESSING' | 'SUCCEEDED' | 'FAILED'

export const ACTIVE_TASK_STATES: readonly BackgroundTaskState[] = ['QUEUED', 'PROCESSING']

export interface BackgroundTask {
  taskId: string
  kind: BackgroundTaskKind
  state: BackgroundTaskState
  label: string
  progressDone: number | null
  progressTotal: number | null
  summary: string
  messagesCount: number
  errorMessage: string
  createdAt: string
  startedAt: string | null
  finishedAt: string | null
}

export interface BackgroundTaskList {
  activeCount: number
  tasks: BackgroundTask[]
}

export interface BackgroundTaskRepository {
  list(): Promise<BackgroundTaskList>
  messages(taskId: string): Promise<string[]>
}
